'use strict';

var CheckableRowsTable = require('./CheckableRowsTable');
/**
 * This object is similar to the CheckableRowsTable, but instead of working
 * with tables that have an arbitrary number of columns, this only allows
 * a checkbox and a text description.
 *
 * Another difference is that the CheckableRowsTable can be applied
 * to HTML that is already in the page, but this widget manages its own
 * DOM objects and all items must be added to the list programmatically using
 * JavaScript.
 */
var CheckableItemsList = function(container, options) {
    this.initialize(container, options);
};
CheckableItemsList._instanceCount = 1;
CheckableItemsList.prototype = {

    //--- Constants ---
    _idPrefix: 'checkableItemId_',

    _tableBody: null,
    _externalIdToInternalIdMap: null,
    _clickListener: null,
    _numItemsAdded: 0,
    _selectedIds: null, //Consider this a HashSet of the user-provided IDs for all the checked items
    _useRadioButtons: false,
    _radioGroupName: null,
    _formFieldName: null,

    /**
	 * @param container - a div DOM element or the ID of one. This is expected
	 *      to be an empty div. If it contains any child nodes, they
	 *      will be removed from the DOM.
	 * @param options - contains the following optional settings:
	 *  	clickListener: a function that will be called when
	 *	 		an item is checked or unchecked.  It will be passed the
	 *          item id, the item description, and a boolean indicating if
	 *          the item is now checked.
	 * 		allowRangeSelection: A boolean that if set to true, will
	 * 			allow the user to check (but not uncheck) a range of
	 * 			rows by clicking on one and releasing on another.
	 * 		clickedCss: the CSS added to a table row if (and only if) the box is checked
     *      useRadioButtons: Switches from check-boxes to radio buttons, and disables range selection
     *      formFieldName: The name of the form field, used if you need to submit the checked items.  The values of the
     *          form fields will be IDs of the items.  If using radio buttons, the name of the form field also
     *          groups radio-buttons into a set that are mutually exclusive to select.
	 */
	initialize: function(container, options) {
        //Give this instance a unique prefix it can use for its items so they don't clash
        //with IDs for items from other CheckableItemsList instances on the same page.
        this._idPrefix = this._idPrefix + CheckableItemsList._instanceCount++ + '_';

        this._selectedIds = {};
        this._externalIdToInternalIdMap = {};

        if (!options) {
            options = {};
        }

        //radioGroupName is deprecated in favor of formFieldName, but MITS Report may still be using it for the calculated columns wizard
        if (!options.formFieldName && options.radioGroupName) {
            options.formFieldName = options.radioGroupName;
        }

        if (options.formFieldName) {
            this._formFieldName = options.formFieldName;
        }

        if (options.useRadioButtons) {
            this._useRadioButtons=true;
            options.allowRangeSelection = false;

            if (!options.formFieldName) {
                this._formFieldName = 'checkableItemsTableRadioGroup_' + CheckableItemsList._instanceCount;
            }
        }


        //replace the provided click-listener with our own internal one
        //that will delegate
        this._clickListener = options.clickListener;
        options.clickListener = this._internalClickListener.bind(this);

        var $container;
        if (typeof container === 'string') {
            $container = jQuery('#' + container);
        } else {
            $container = jQuery(container);
        }
        $container.empty();

        var table = document.createElement('table');
        table.classList.add("table", "table-condensed");
        $container.append(table);

        //IE won't display our table rows if we add them directly
        //to the table. So we have to create this head/foot/body junk
        //and add the rows to the body.
        table.appendChild(document.createElement('thead'));
        table.appendChild(document.createElement('tfoot'));
        this._tableBody = document.createElement('tbody');
        table.appendChild(this._tableBody);

        this._checkableRowsTable = new CheckableRowsTable(table, options);
    },

    addItem: function(id, description, initiallyChecked) {

        //Map from the user-provided ID to another unique IDs in case the
        //provided ID has characters that are invalid for HTML ID values.
        var internalId = this._idPrefix + this._numItemsAdded++;
        this._externalIdToInternalIdMap[id] = internalId;


        var row = document.createElement('tr');
        var cell = document.createElement('td');
        var checkbox = document.createElement('input');
        if (this._useRadioButtons) {
            checkbox.type = 'radio';
            checkbox.name = this._formFieldName;
        }
        else {
            checkbox.type = 'checkbox';
            if (this._formFieldName) {
                checkbox.name = this._formFieldName;
            }
        }

        checkbox.id = internalId;
        checkbox.value = id;
        //We set the defaultChecked instead of checked
        //because IE resets the checked property to the
        //default when the element is added to the DOM
        if (initiallyChecked) {
            checkbox.defaultChecked = true;
            this._selectedIds[id] = id;
        }

        cell.style.width = '1%';
        cell.appendChild(checkbox);
        row.appendChild(cell);

        cell = document.createElement('td');
		cell.style.verticalAlign = 'middle';

        var text = document.createTextNode(description);
        cell.appendChild(text);

        row.appendChild(cell);

        this._tableBody.appendChild(row);

        if (this._numItemsAdded % 2 === 1) {
            row.className = 'oddRow';
        }
        else {
            row.className = 'evenRow';
        }

        this._checkableRowsTable.prepareRow(row);
    },

    addAdditionalItemsNotice: function (msg) {
        var additionalItems = jQuery('<tr><td colspan="2" style="font-style: italic; height: 3em; text-align: center; vertical-align: middle; color: red; font-size: larger;">' + msg + '</td></tr>');
        additionalItems.appendTo(this._tableBody);
    },

    uncheckAllItems: function() {
        this._checkableRowsTable.uncheckAllRows();
        this._selectedIds = {};
    },

    checkItem: function(id) {
        this.setChecked(id, true);
    },

    uncheckItem: function(id) {
        this.setChecked(id, false);
    },

    //Silently handles invalid IDs
    setChecked: function(id, checked) {
        if (checked) {
            this._selectedIds[id] = id;
        }
        else {
            delete this._selectedIds[id];
        }
        var internalId = this._externalIdToInternalIdMap[id];
        var checkbox = document.getElementById(internalId);
        if (checkbox) {
            checkbox.checked = checked;
            this._checkableRowsTable.updateClickedCss(checkbox);
        }
    },

    isChecked: function(id) {
        var internalId = this._externalIdToInternalIdMap[id];
        var checkbox = document.getElementById(internalId);
        return checkbox.checked;
    },

    getCheckedIds: function() {
        return Object.keys(this._selectedIds); //returns an array of Strings
    },

    getInternalId: function(id) {
        return this._externalIdToInternalIdMap[id];
    },


    _internalClickListener: function(checkbox) {
        var row = checkbox.parentNode.parentNode;
        var cell2 = row.lastChild;
        var id = checkbox.value;
        var label = cell2.firstChild.data;
        var isChecked = checkbox.checked;

        if (isChecked) {
            this._selectedIds[id] = id;
        }
        else {
            delete this._selectedIds[id];
        }

        if (this._clickListener) {
            this._clickListener(id, label, isChecked);
        }
    }
};

module.exports = CheckableItemsList;


//////////////////
// WEBPACK FOOTER
// ./mits/Widgets/CheckableItemsList.js
// module id = 17
// module chunks = 0